import { useMutation, useQueryClient } from "react-query";
import immer from "immer";
import { useContext } from "react";
import { toast } from "react-toastify";
import { FetchContext } from "../context/FetchContext";

export const useTranslate = (projectId, version) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();
  const queryKey = [
    "project",
    projectId,
    "version",
    version?.toString(),
    "keys",
  ];
  return useMutation(
    async (key) => {
      const { data } = await fetchContext.authAxios.post(
        `/projects/${projectId}/keys/${key}/translate`
      );
      return data;
    },
    {
      onSettled: (data, error, keyId) => {
        queryClient
          .getQueryCache()
          .findAll(queryKey)
          .forEach(({ queryKey }) => {
            const previousKeys = queryClient.getQueryData(queryKey);
            const newKeys = immer(previousKeys, (draft) => {
              const index = draft.findIndex((key) => key.id === keyId);
              if (index !== -1) {
                draft[index] = data;
              }
            });
            queryClient.setQueryData(queryKey, newKeys);
          });
        toast.success("Translation Completed");
      },
    }
  );
};
